<template>

  <v-flex
    xs12
    md6
    sm4
  >
    <wipeDialog
      :assetTag="assetDetail.Discovery.AssetTag"
      v-if="Wipedialog"
      v-on:Modalclose="Wipedialog = false"
    />
    <dymoPrintPreview
      v-on:Modalclose="Printdialog = false"
      v-if="Printdialog && !annoy"
      :assets="[assetDetail]"
    />
    <MagentoDetail
      v-on:mageModalclose="magentoDialog = false"
      :assetList='[assetDetail]'
      v-if="magentoDialog && !annoy"
    />

    <EditDetailsComputer
      v-on:computerDetailModalClose="computerDetailDialog = false"
      v-if='computerDetailDialog && !annoy'
      :assetDetail='assetDetail'
    />
    <v-card class='mt-5'>
      <v-toolbar
        color="secondary"
        dark
      >
        <v-toolbar-title>{{assetDetail.Discovery.AssetTag}}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-avatar
          v-if='!annoy'
          @click='magentoDialog = true'
          :tile="true"
          :size="25"
        >
          <img
            style='cursor : pointer ; width : 100% ;margin-right : 50%'
            title='push item to magento'
            src="https://firebasestorage.googleapis.com/v0/b/tech-reuse.appspot.com/o/112651_development_435x512.png?alt=media&token=842aeaf9-f41d-4b86-a0d3-471952d2d437"
          >
        </v-avatar>
        <v-btn
          icon
          v-if='!annoy'
          @click="Printdialog= true"
        >
          <v-icon>print</v-icon>
        </v-btn>
        <v-btn
          v-if='!annoy'
          icon
          @click="computerDetailDialog = true"
        >
          <v-icon>edit</v-icon>
        </v-btn>
        <v-btn
          v-if='assetDetail.WipedHDDs'
          @click="Wipedialog = true"
          flat
          icon
        >
          <v-icon>camera_rear</v-icon>
        </v-btn>
        <v-btn
          v-if='!annoy'
          icon
          @click="save"
        >
          <v-icon>save</v-icon>
        </v-btn>
      </v-toolbar>

      <v-list two-line>
        <p
          v-if="annoy"
          class='headline font-weight-bold'
        >PROOF OF REFURBISHMENT</p>
        <p
          v-if="annoy"
          class='subheading'
        >This devices has been tested and verifed by a TechSpec certified organization. All components have been tested to ensure they are fully functional. All hardwared specifications have been recorded and are listed below. </p>
        <span class='font-weight-bold'>{{assetDetail.Discovery.SystemInfo.Make}} {{assetDetail.Discovery.SystemInfo.Model}} {{assetDetail.Discovery.CpuTitle}}, {{assetDetail.Discovery.RamTitle}} GB RAM, {{assetDetail.Discovery.HddTitle}} GB HDD</span>
        <v-text-field
          class='pl-3 pr-3'
          :disabled='disabled'
          v-model='assetDetail.mischardwarespec.conditionDesc'
          label="Condition Description"
        ></v-text-field>
        <v-list-tile>
          <v-list-tile-action>
            <v-avatar
              :tile="true"
              :size="30"
            >
              <img src="https://img.icons8.com/ios/50/000000/organization-filled.png">
            </v-avatar>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>{{assetDetail.Discovery.SystemInfo.Make}}</v-list-tile-title>
            <v-list-tile-sub-title>Make</v-list-tile-sub-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-divider inset></v-divider>
        <v-list-tile>
          <v-list-tile-action>
            <v-avatar
              :tile="true"
              :size="30"
            >
              <img src="https://img.icons8.com/material/48/000000/laptop.png">
            </v-avatar>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>{{assetDetail.Discovery.SystemInfo.Model}}</v-list-tile-title>
            <v-list-tile-sub-title>Model</v-list-tile-sub-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-divider inset></v-divider>
        <v-list-tile>
          <v-list-tile-action>
            <v-avatar
              :tile="true"
              :size="30"
            >
              <img src="https://img.icons8.com/ios/50/000000/bag-brand.png">
            </v-avatar>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>{{assetDetail.Discovery.SystemInfo.Serial}}</v-list-tile-title>
            <v-list-tile-sub-title>Serial</v-list-tile-sub-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-divider inset></v-divider>
        <v-list-tile>
          <v-list-tile-action>
            <v-avatar
              :tile="true"
              :size="30"
            >
              <img src="https://img.icons8.com/metro/52/000000/processor.png">
            </v-avatar>
          </v-list-tile-action>

          <v-list-tile-content>
            <v-list-tile-title>{{assetDetail.Discovery.CpuTitle}}</v-list-tile-title>
            <v-list-tile-sub-title>Processor</v-list-tile-sub-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-divider inset></v-divider>
        <v-list-tile>
          <v-list-tile-action>
            <v-avatar
              :tile="true"
              :size="30"
            >
              <img src="https://img.icons8.com/wired/64/000000/memory-slot.png">
            </v-avatar>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>{{assetDetail.Discovery.RamTitle}} GB</v-list-tile-title>
            <v-list-tile-sub-title>Memory</v-list-tile-sub-title>
          </v-list-tile-content>
        </v-list-tile>

        <v-divider inset></v-divider>

        <v-list-tile>
          <v-list-tile-action>
            <v-avatar
              :tile="true"
              :size="30"
            >
              <img src="https://img.icons8.com/ios/50/000000/hdd-filled.png">
            </v-avatar>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>{{assetDetail.Discovery.HddTitle}} GB</v-list-tile-title>
            <v-list-tile-sub-title>Storage</v-list-tile-sub-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-divider inset></v-divider>
        <v-list-tile>
          <v-list-tile-action>
            <v-avatar
              :tile="true"
              :size="30"
            >
              <img src="https://img.icons8.com/ios/100/000000/video-card-filled.png">
            </v-avatar>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title v-if='assetDetail.Discovery.GraphCardsInfo'>{{assetDetail.Discovery.GraphCardsInfo[0].GraphicCardName}}</v-list-tile-title>
            <v-list-tile-sub-title>Video Card</v-list-tile-sub-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-divider inset></v-divider>
        <v-list-tile>
          <v-list-tile-action>
            <v-avatar
              :tile="true"
              :size="30"
            >
              <img src="https://img.icons8.com/metro/52/000000/pallet.png">
            </v-avatar>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title
              v-if='assetDetail.Discovery.location'
              style='cursor : pointer;color:blue'
              @click='goTo'
            >{{assetDetail.Discovery.location}}</v-list-tile-title>
            <v-list-tile-sub-title>Location</v-list-tile-sub-title>
          </v-list-tile-content>
        </v-list-tile>
            <v-divider inset></v-divider>
        <v-list-tile>
          <v-list-tile-action>
            <v-avatar
              :tile="true"
              :size="30"
            >
            <img src="https://img.icons8.com/ios-filled/50/000000/windows-logo.png"/>
            </v-avatar>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title
              v-if='assetDetail.osInstall'
            ><v-icon color='green'>check</v-icon>Windows operating system successfully installed.</v-list-tile-title>
            <v-list-tile-sub-title>OS Install</v-list-tile-sub-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
      <v-text-field
        :disabled='disabled'
        class='pl-3 pr-3'
        v-model='assetDetail.sku'
        label="SKU"
      ></v-text-field>
      <v-select
        :disabled='disabled'
        :items='computerType'
        class='pl-3 pr-3'
        v-model='assetDetail.mischardwarespec.computerType'
        label="Type"
      ></v-select>
      <v-select
        :disabled='disabled'
        :items='storageType'
        class='pl-3 pr-3'
        v-model='assetDetail.mischardwarespec.storageType'
        label="Storage Type"
      ></v-select>
      <v-text-field
        :disabled='disabled'
        class='pl-3 pr-3'
        v-model='assetDetail.mischardwarespec.screensize'
        label="Screen Size"
        type='number'
      ></v-text-field>
      <v-text-field
        :disabled='disabled'
        class='pl-3 pr-3'
        v-model='assetDetail.Discovery.OsTitle'
        label="Operating System and Edition"
      ></v-text-field>
      <v-text-field
        :disabled='disabled'
        class='pl-3 pr-3'
        v-model='assetDetail.mischardwarespec.color'
        label="Color"
      ></v-text-field>
      <v-container fluid>
        <v-layout
          row
          wrap
        >
          <v-flex
            v-for='(item,index) in checkBoxesList'
            sm4
            md4
            :key='index'
          >
            <v-checkbox
              :disabled='disabled'
              :label='item.name'
              v-model='assetDetail.mischardwarespec[item.value]'
              hide-details
            ></v-checkbox>

          </v-flex>
        </v-layout>
      </v-container>
    </v-card>
    <v-card
      class='mt-5'
      v-if='!assetDetail'
    >
      <v-card-title primary-title>
        <div>
          <h3 class="headline mb-0">No Record for asset {{ this.$route.params.id}} </h3>
        </div>
      </v-card-title>

    </v-card>
  </v-flex>
</template>



<script>
import MagentoDetail from '../components/MagentoDialog.vue'
import dymoPrintPreview from '../components/PrintPreview.vue'
import EditDetailsComputer from '../components/EditDetailsComputer'
import wipeDialog from '../components/dialogs/WipehddsDialog'
const fb = require('../firebaseConfig.js')
import { mapFields } from 'vuex-map-fields';

export default {
  components: {
    wipeDialog,
    dymoPrintPreview,
    MagentoDetail,
    EditDetailsComputer
  },
  props: {
    assetDetail: Object,
    annoy: Boolean
  },
  computed: {
    ...mapFields([
      "snackBarMessage",
      "snackBar",
      "snackBarcolor"
    ])  },
  methods: {
    save () {
      fb.AssetsCollections.where("Discovery.AssetTag", "==", this.$route.params.id).get().then(d => {
        d.forEach((doc) => {
          var docID = doc.id
          fb.AssetsCollections.doc(docID).set(this.assetDetail).then(() => {
            this.snackBar = true
            this.snackBarMessage = "update completed"
            this.snackBarcolor = "success"
          })

        })
      })
    }
  },
  mounted () {
    if (this.annoy) {
      this.disabled = true
    }
  },
  data () {
    return {
      storageType: [
        "eMMC",
        "HDD (Hard Disk Drive)",
        "HDD + SSD",
        "SSD (Solid State Drive)",
        "SSHD (Solid State Hybrid Drive)"
      ],
      checkBoxesList: [
        { name: "DisplayPort", value: "displayPort" },
        { name: "Gigabit Ethernet", value: "ethernet" },
        { name: "Mini DisplayPort", value: "minidisplayport" },
        { name: "HDMI", value: "hdmi" },
        { name: "Micro-HDMI", value: "microHDMI" },
        { name: "Micro-USB", value: "microUSB" },
        { name: "Mini Gigabit Ethernet", value: "miniEthernet" },
        { name: "Mini-USB", value: "miniUSB" },
        { name: "USB 1.0/1.1", value: "usb1" },
        { name: "USB 2.0", value: "usb2" },
        { name: "10/100 LAN Card", value: "lanCard" },
        { name: "3D Camera", value: "camera3d" },
        { name: "Backlit Keyboard", value: "backLitKeyboard" },
        { name: "Bluetooth", value: "bluetooth" },
        { name: "Built-in Microphone", value: "microphone" },
        { name: "Built-in Webcam", value: "webcam" },
        { name: "HSDPA", value: "hsdpa" },
        { name: "Rugged", value: "rugged" },
        { name: "Tablet PC", value: "tabletPC" },
        { name: "Touchscreen", value: "touchScreen" }
      ],
      computerType: [
        "Desktop",
        "Notebook / Laptop",
        "Ultrabook",
        "Subnotebook / Ultraportable",
        "Convertible 2 -in -1 Laptop / Tablet",
        "Netbook",
        "Ultra - mobile PC",
        "Chromebook",
        "Gaming Laptop",
        "Thinkpad"],
      disabled: false,
      Wipedialog: false,
      Printdialog: false,
      magentoDialog: false,
      computerDetailDialog: false
    }
  },
}
</script>
